import { http } from '@4beefopag/4bee-fopag-core/dist/services';
import { logoff as coreLogoff } from '@4beefopag/4bee-fopag-core/dist/services/menu';
import { createMongoAbility } from '@casl/ability';
import { deleteCookie } from '../util/cookies';
import { apiClient } from '../util/http';
import { getItem, setItem } from '../util/localStorage';

export const logoff = async () => {
  localStorage.removeItem('fopag.auth.user-policy');
  deleteCookie('fopag.token');
  await coreLogoff();
};

const getTokenFromApi = async () => {
  const response = await http.get(`${process.env.REACT_APP_LOGIN_API_URL}api/token`, { withCredentials: true });
  return response.data && response.data.raw;
};

export const getToken = async () => {
  const token = localStorage.getItem('fopag.auth.token');
  if (token) {
    return token;
  }

  // Busca pelo token dos cookies recebido pelo redirect do sistema de login
  const tokenFromApi = await getTokenFromApi();
  if (tokenFromApi) {
    // Mantido o token no local storage, pois é utilizado no interceptor das requisições http.
    // @TODO: Será que precisa salvar o token no localStorage, não daria pra manter só no cookie?
    localStorage.setItem('fopag.auth.token', tokenFromApi);
    return tokenFromApi;
  }

  return undefined;
};

const serializeUserAccount = (userAccount) => {
  const ability = createMongoAbility(userAccount.abilityRules);

  return {
    ...userAccount,
    ability,
  };
};

export const getUserAccount = async () => {
  const cachedUserPolicy = getItem('fopag.auth.user-policy');
  if (cachedUserPolicy && cachedUserPolicy?.abilityRules?.length > 0) {
    return serializeUserAccount(cachedUserPolicy);
  }

  const { data } = await apiClient.get('user-policy/user-account');
  setItem('fopag.auth.user-policy', data);

  return serializeUserAccount(data);
};
